interface isa_introES {
  intro_title: string;
  intro_desc: string;
}

export const isa_introES: isa_introES = {
  intro_title: "¿QUÉ ES LA EVALUACIÓN DE SELECCIÓN DE IMPETUS?",
  intro_desc:
    "La evaluación de selección de Impetus es una herramienta para ayudar a identificar el impulso que mejor se alinea con las expectativas y objetivos de tu negocio.",
};

interface isa_videoES {
  cookies_desc: string;
  button_desc: string;
}

export const isa_videoES: isa_videoES = {
  cookies_desc:
    "Por favor acepta nuestras cookies para ver el video demostrativo aquí o mira el video en nuestro canal.",
  button_desc: "Ver el video en YouTube",
};

interface isa_instructES {
  ins_title: string;
  ins_desc: string;
  ins_sub_title_1: string;
  ins_sub_desc_1: string;
  ins_sub_title_2: string;
  ins_sub_desc_2: string;
  ins_sub_title_3: string;
  ins_sub_desc_3_1: string;
  ins_sub_desc_3_2: string;
  ins_sub_title_4: string;
  ins_sub_desc_4_1: string;
  ins_sub_desc_4_2: string;
  ins_sub_desc_4_3: string;

  ins_video_title: string;
  ins_video_message: string;
  ins_video_button: string;
}

export const isa_instructES: isa_instructES = {
  ins_title: "INSTRUCCIONES",
  ins_desc:
    "Esta herramienta utiliza una serie de preguntas para conocer la importancia de ciertos procedimientos en tu negocio y los cambios que estás dispuesto a hacer para mejorar tu empresa. Para conocer con precisión los resultados de la evaluación de selección de Impetus, es importante responder de acuerdo con la situación de tu negocio.",
  ins_sub_title_1: "Expectativas y esfuerzo",
  ins_sub_desc_1:
    "Una vez que inicies la herramienta, verás dos secciones. La primera sección es un gráfico de barras horizontal que mostrará el estado de los cuatro Impetus en tu negocio. Este gráfico cambiará automáticamente de acuerdo con las respuestas dadas en la segunda sección.",
  ins_sub_title_2: "Preguntas para tu Impetus ",
  ins_sub_desc_2:
    "TLa segunda sección contiene las preguntas que deben responderse para obtener los resultados de la evaluación de selección de Impetus. Cada pregunta se responde con una de las tres opciones de respuesta que se muestran debajo de las preguntas. Si es necesario, también es posible dar una breve explicación a cada respuesta utilizando el cuadro de texto ubicado debajo de las opciones de respuesta.",
  ins_sub_title_3: "Información útil",
  ins_sub_desc_3_1:
    "Algunas preguntas muestran información adicional que puede ayudar a entenderlas; para ver esta información adicional, debes seleccionar el botón “info adicional” que mostrará un cuadro de texto con dicha información.",
  ins_sub_desc_3_2:
    "Si deseas rehacer las preguntas, selecciona el botón “reiniciar preguntas” para comenzar desde la primera pregunta. Para avanzar a la siguiente pregunta, es necesario responder la pregunta actual y seleccionar el botón “siguiente.” ",
  ins_sub_title_4: "Obtener los resultados de la herramienta",
  ins_sub_desc_4_1:
    "Una vez que se hayan respondido todas las preguntas, la herramienta mostrará el gráfico final como resultado; este gráfico final indicará en qué Impetus te estás enfocando para mejorar tu negocio y cuáles son los Impetus a los que estás dedicando esfuerzos para mejorar.",
  ins_sub_desc_4_2:
    "La herramienta ahora muestra dos opciones: una es el botón “reiniciar” mencionado previamente y la otra opción es el botón “obtener resultados” el cual muestra una sección para que proporciones el correo electrónico que recibirá los resultados de esta herramienta.",
  ins_sub_desc_4_3:
    "Los resultados se enviarán al correo proporcionado en formato PDF (este PDF contendrá el gráfico final y las preguntas respondidas con sus respectivos comentarios, si los hubiera).",

  ins_video_title:
    "Si necesitas ayuda para entender esta herramienta, aquí tienes un video demostrativo:",
  ins_video_message:
    "Una vez que estés listo para comenzar la evaluación de selección Impetus, por favor selecciona el botón de abajo.",
  ins_video_button: "Comenzar la herramienta",
};

interface isa_messageES {
  message_title: string;
  message_desc: string;
}

export const isa_messageES: isa_messageES = {
  message_title: "EVALUACIÓN DE SELECCIÓN DE IMPETUS",
  message_desc:
    "Por favor, selecciona tu respuesta de acuerdo con los criterios de tu negocio:",
};

interface isa_graphES {
  data_label_1: string;
  data_label_2: string;
  data_label_3: string;
  data_label_4: string;
  data_label_5: string;
  data_label_6: string;
  data_label_7: string;
  data_set_1: string;
  data_set_2: string;

  qstn_1: string;
  qstn_2: string;
  qstn_3: string;
  qstn_4: string;
  qstn_5: string;
  qstn_6: string;
  qstn_7: string;
  qstn_8: string;
  qstn_9: string;
  qstn_10: string;
  qstn_11: string;
  qstn_12: string;
  qstn_13: string;
  qstn_14: string;
  qstn_15: string;
  qstn_16: string;
  qstn_17: string;
  qstn_18: string;
  qstn_19: string;
  qstn_20: string;
  qstn_21: string;
  qstn_22: string;
  qstn_23: string;

  as1_1: string;
  as1_2: string;
  as1_3: string;
  as1_4: string;
  as1_5: string;
  as1_6: string;
  as1_7: string;
  as1_8: string;
  as1_9: string;
  as1_10: string;
  as1_11: string;
  as1_12: string;
  as1_13: string;
  as1_14: string;
  as1_15: string;
  as1_16: string;
  as1_17: string;
  as1_18: string;
  as1_19: string;
  as1_20: string;
  as1_21: string;
  as1_22: string;

  as2_1: string;
  as2_2: string;
  as2_3: string;
  as2_4: string;
  as2_5: string;
  as2_6: string;
  as2_7: string;
  as2_8: string;
  as2_9: string;
  as2_10: string;
  as2_11: string;
  as2_12: string;
  as2_13: string;
  as2_14: string;
  as2_15: string;
  as2_16: string;
  as2_17: string;
  as2_18: string;
  as2_19: string;
  as2_20: string;
  as2_21: string;
  as2_22: string;

  as3_1: string;
  as3_2: string;
  as3_3: string;
  as3_4: string;
  as3_5: string;
  as3_6: string;
  as3_7: string;
  as3_8: string;
  as3_9: string;
  as3_10: string;
  as3_11: string;
  as3_12: string;
  as3_13: string;
  as3_14: string;
  as3_15: string;
  as3_16: string;
  as3_17: string;
  as3_18: string;
  as3_19: string;
  as3_20: string;
  as3_21: string;
  as3_22: string;

  addinfo_1: string;
  addinfo_2: string;
  addinfo_3: string;
  addinfo_4: string;
  addinfo_5: string;
  addinfo_6: string;
  addinfo_7: string;

  button_reset: string;
  modal_question_reset: string;
  modal_question_reset_yes: string;
  modal_question_reset_no: string;
  question_index_1: string;
  question_index_2: string;

  text_area: string;
  button_previous: string;
  button_next: string;
  button_additional: string;
  button_results: string;
  no_comment: string;
  pdf_question_index_1: string;
  pdf_question_index_2: string;
  pdf_answer: string;
  pdf_comments: string;
  error_email_1: string;
  error_email_2: string;
  error_name: string;
  error_last_name: string;
  error_phone_1: string;
  error_phone_2: string;

  graph_title: string;

  modal_email_title: string;
  modal_email_desc: string;
  modal_email_label: string;
  modal_email: string;
  modal_name_label: string;
  modal_name: string;
  modal_last_name_label: string;
  modal_last_name: string;
  modal_phone_number_label: string;
  modal_phone_number: string;
  modal_email_send: string;
  wait_email_title: string;
  wait_email: string;
  success_email_title: string;
  success_email: string;
  success_understood: string;
  error_email_title: string;
  error_email: string;
  error_understood: string;
}

export const isa_graphES: isa_graphES = {
  data_label_1: "GESTIÓN",
  data_label_2: "DIARIA",
  data_label_3: "MEJORA",
  data_label_4: "CONTÍNUA",
  data_label_5: "TRANSFORMACIÓN",
  data_label_6: "DE NEGOCIO",
  data_label_7: "INNOVACIÓN",
  data_set_1: "ESFUERZO",
  data_set_2: "EXPECTATIVAS",

  qstn_1:
    "¿Qué tan importantes son los beneficios financieros para tu negocio?",
  qstn_2: "¿Qué tan importantes son las mejoras visibles para tu negocio?",
  qstn_3:
    "¿Qué tan importante es que los clientes perciban las mejoras para tu negocio?",
  qstn_4:
    "¿Qué tan importante es aumentar el compromiso de los empleados para tu negocio?",
  qstn_5:
    "¿Qué tan importante es desarrollar una cultura enfocada en el cliente para tu negocio?",
  qstn_6:
    "¿Qué tan importante es mejorar la participación del liderazgo para tu negocio?",
  qstn_7: "¿Qué tan rápido quieres ver las mejoras?",
  qstn_8: "¿Estás dispuesto a realizar nuevas tareas para tu negocio?",
  qstn_9: "¿Estás dispuesto a asumir nuevas responsabilidades para tu negocio?",
  qstn_10: "¿Estás dispuesto a crear nuevos roles para tu negocio?",
  qstn_11:
    "¿Estás dispuesto a hacer una reubicación local de tu lugar de trabajo para tu negocio?",
  qstn_12:
    "¿Estás dispuesto a realizar cambios estructurales en los reportes para tu negocio?",
  qstn_13:
    "¿Está el equipo de liderazgo de tu negocio dispuesto a proporcionar orientación y/o aportes?",
  qstn_14:
    "¿Está el equipo de liderazgo de tu negocio dispuesto a mostrar un comportamiento nuevo?",
  qstn_15:
    "¿Está el equipo de liderazgo de tu negocio dispuesto a mostrar participación activa y compromiso con los resultados?",
  qstn_16:
    "¿Estás dispuesto a realizar cambios tecnológicos para tu negocio, como adquirir equipo de venta libre?",
  qstn_17:
    "¿Estás dispuesto a realizar cambios tecnológicos para tu negocio, como desarrollar nuevos informes y/o interfaces?",
  qstn_18:
    "¿Estás dispuesto a realizar cambios tecnológicos para tu negocio, como cambiar los sistemas y/o equipos actuales?",
  qstn_19:
    "¿Estás dispuesto a realizar cambios tecnológicos como desarrollar nuevos sistemas y/o equipos?",
  qstn_20:
    "¿Estás dispuesto a asumir riesgos para tu negocio, como resultados impredecibles?",
  qstn_21:
    "¿Estás dispuesto a asumir riesgos para tu negocio, como hacer cambios no reversibles?",
  qstn_22:
    "¿Estás dispuesto a asumir riesgos para tu negocio, como hacer inversiones de capital medianas/altas?",
  qstn_23: "Los parámetros han sido completados, aquí están los resultados.",

  as1_1: "No tan importante",
  as1_2: "No tan importante",
  as1_3: "No tan importante",
  as1_4: "No tan importante",
  as1_5: "No tan importante",
  as1_6: "No tan importante",
  as1_7: "Años (1-4)",
  as1_8: "Definitivamente no",
  as1_9: "Definitivamente no",
  as1_10: "Definitivamente no",
  as1_11: "Definitivamente no",
  as1_12: "Definitivamente no",
  as1_13: "Definitivamente no",
  as1_14: "Definitivamente no",
  as1_15: "Definitivamente no",
  as1_16: "Definitivamente no",
  as1_17: "Definitivamente no",
  as1_18: "Definitivamente no",
  as1_19: "Definitivamente no",
  as1_20: "Definitivamente no",
  as1_21: "Definitivamente no",
  as1_22: "Definitivamente no",

  as2_1: "Importante",
  as2_2: "Importante",
  as2_3: "Importante",
  as2_4: "Importante",
  as2_5: "Importante",
  as2_6: "Importante",
  as2_7: "Meses (9-14)",
  as2_8: "Solo si es necesario, pero buscaremos atajos primero",
  as2_9: "Solo si es necesario, pero buscaremos atajos primero",
  as2_10: "Solo si es necesario, pero buscaremos atajos primero",
  as2_11: "Solo si es necesario, pero buscaremos atajos primero",
  as2_12: "Solo si es necesario, pero buscaremos atajos primero",
  as2_13: "Solo si es necesario, pero buscaremos atajos primero",
  as2_14: "Solo si es necesario, pero buscaremos atajos primero",
  as2_15: "Solo si es necesario, pero buscaremos atajos primero",
  as2_16: "Solo si es necesario, pero buscaremos atajos primero",
  as2_17: "Solo si es necesario, pero buscaremos atajos primero",
  as2_18: "Solo si es necesario, pero buscaremos atajos primero",
  as2_19: "Solo si es necesario, pero buscaremos atajos primero",
  as2_20: "Solo si es necesario, pero buscaremos atajos primero",
  as2_21: "Solo si es necesario, pero buscaremos atajos primero",
  as2_22: "Solo si es necesario, pero buscaremos atajos primero",

  as3_1: "Muy importante",
  as3_2: "Muy importante",
  as3_3: "Muy importante",
  as3_4: "Muy importante",
  as3_5: "Muy importante",
  as3_6: "Muy importante",
  as3_7: "Semanas (12-24)",
  as3_8: "Queremos hacer esto bien, así que se hará como debe ser",
  as3_9: "Queremos hacer esto bien, así que se hará como debe ser",
  as3_10: "Queremos hacer esto bien, así que se hará como debe ser",
  as3_11: "Queremos hacer esto bien, así que se hará como debe ser",
  as3_12: "Queremos hacer esto bien, así que se hará como debe ser",
  as3_13: "Queremos hacer esto bien, así que se hará como debe ser",
  as3_14: "Queremos hacer esto bien, así que se hará como debe ser",
  as3_15: "Queremos hacer esto bien, así que se hará como debe ser",
  as3_16: "Queremos hacer esto bien, así que se hará como debe ser",
  as3_17: "Queremos hacer esto bien, así que se hará como debe ser",
  as3_18: "Queremos hacer esto bien, así que se hará como debe ser",
  as3_19: "Queremos hacer esto bien, así que se hará como debe ser",
  as3_20: "Queremos hacer esto bien, así que se hará como debe ser",
  as3_21: "Queremos hacer esto bien, así que se hará como debe ser",
  as3_22: "Queremos hacer esto bien, así que se hará como debe ser",

  addinfo_1: "Ahorros directos con impacto en el presupuesto.",
  addinfo_2:
    "Cambios audaces en los procesos que mejoran significativamente el rendimiento del proceso.",
  addinfo_3:
    "Mejoras en el tiempo de entrega, calidad y/o costos claramente percibidas por los clientes.",
  addinfo_4:
    "Medido como propiedad y participación en la resolución de oportunidades de mejora.",
  addinfo_5:
    "Una cultura donde la satisfacción del cliente externo es el principal factor en el proceso de toma de decisiones.",
  addinfo_6:
    "Desarrollar un entorno de liderazgo orientado a resultados y basado en las personas, con sesgo hacia la acción.",
  addinfo_7:
    "Tiempo de espera para percibir las mejoras, desde unas pocas semanas hasta más de un año.",

  button_reset: "Restablecer preguntas",
  modal_question_reset: "¿Quieres restablecer todas las preguntas?",
  modal_question_reset_yes: "Sí",
  modal_question_reset_no: "No",
  question_index_1: "Pregunta",
  question_index_2: "de",

  text_area: "Explicación de las respuestas (opcional)",
  button_additional: "Información adicional",
  button_previous: "Anterior",
  button_next: "Siguiente",
  button_results: "Obtener resultados",
  no_comment: "Sin comentario",
  pdf_question_index_1: "Pregunta ",
  pdf_question_index_2: " de ",
  pdf_answer: "Tu respuesta:",
  pdf_comments: "Tus comentarios:",
  error_email_1: "Por favor, ingresa tu correo electrónico.",
  error_email_2:
    "Por favor, ingresa una dirección de correo electrónico válida.",
  error_name: "Por favor, ingresa tu nombre.",
  error_last_name: "Por favor, ingresa tu apellido.",
  error_phone_1: "Por favor, ingresa tu número de teléfono.",
  error_phone_2: "El número de teléfono debe tener al menos 10 caracteres.",

  graph_title: "EXPECTATIVAS Y ESFUERZO",

  modal_email_title: "Compartir información de contacto",
  modal_email_desc: "Comparte tu información de contacto para los resultados",
  modal_email_label: "CORREO ELECTRÓNICO:",
  modal_email: "Correo electrónico",

  modal_name_label: "NOMBRE:",
  modal_name: "Nombre",
  modal_last_name_label: "APELLIDO:",
  modal_last_name: "Apellido",
  modal_phone_number_label: "NÚMERO DE TELÉFONO:",
  modal_phone_number: "Número de teléfono",

  modal_email_send: "Enviar resultados",
  wait_email_title: "Por favor espera un momento",
  wait_email: "Generando PDF y mensaje de correo electrónico...",

  success_email_title: "Correo enviado",
  success_email: "Tus resultados fueron enviados por correo electrónico",
  success_understood: "Entendido",

  error_email_title: "¡Ups! Algo salió mal",
  error_email: "Ha ocurrido un error, por favor intenta nuevamente",
  error_understood: "Entendido",
};
